import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import "./reset.css";
import App from "./components/App";
import Welcome from "./components/Welcome";
import Help from "./components/Help";
import Logout from "./components/Logout";
import Feedback from "./components/Feedback";
import NewClient from "./components/NewClient";
import Dashboard from "./components/Dashboard";
import Bookkeeping from "./components/Bookkeeping";
import Calculator from "./components/Calculator";
import Main from "./components/Main";
import EditClient from "./components/EditClient";
import EditCar from "./components/EditCar";
import EditUser from "./components/EditUser";
import EditContract from "./components/EditContract";
import Credit from "./components/Credit";
import Loan from "./components/Loan";
import ClientsTable from "./components/ClientsTable";
import ContractsTable from "./components/ContractsTable";
import NotFound from "./components/NotFound";
import Hidden from "./components/Hidden";
import Shutdown from "./components/Shutdown";
// import registerServiceWorker from "./registerServiceWorker";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import store from "./store";
import { addLocaleData, IntlProvider } from "react-intl";
import ruLocaleData from "react-intl/locale-data/ru";
import "moment/locale/ru";

addLocaleData(ruLocaleData);


ReactDOM.render((
    <Provider store={store}>
      <IntlProvider locale="ru">
        <Router>
          <App>
            <Switch>
              <Route exact path="/welcome" component={Welcome}/>
              <Route exact path="/shutdown" component={Shutdown}/>
              <Hidden>
                <Switch>
                  <Route exact path="/" component={Main}/>
                  <Route exact path="/logout" component={Logout}/>
                  <Route exact path="/client/new/" component={NewClient}/>
                  <Route exact path="/loans" component={ClientsTable}/>
                  <Route exact path="/help" component={Help}/>
                  <Route exact path="/calculator" component={Calculator}/>
                  <Route path="/contracts/:prefilter" component={ContractsTable}/>
                  <Route path="/client/:clientId/car/:carId" component={Loan}/>
                  <Route path="/client/:clientId/editcar/:carId" component={EditCar}/>
                  <Route path="/client/:clientId/editcontract/:carId" component={EditContract}/>
                  <Route path="/client/:clientId" component={EditClient}/>
                  <Route path="/user/:userId" component={EditUser}/>
                  <Route path="/credit/:creditId" component={Credit}/>
                  <Route path="/feedback" component={Feedback}/>
                  <Route path="/dashboard/:tab?" component={Dashboard}/>
                  <Route path="/bookkeeping/:tab?" component={Bookkeeping}/>
                  <Route path="*" component={NotFound}/>
                </Switch>
              </Hidden>
            </Switch>
          </App>
        </Router>
      </IntlProvider>
    </Provider>
), document.getElementById("root"));

// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js